"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.fetchActivitiesFailure = exports.fetchActivitiesSuccess = exports.fetchActivitiesRequest = exports.fetchActivityTypesFailure = exports.fetchActivityTypesSuccess = exports.fetchActivityTypesRequest = void 0;
const ActionTypes = require("../../actionTypes/activity/list");
function fetchActivityTypesRequest(briefcaseUuid) {
    return {
        type: ActionTypes.FETCH_ACTIVITY_TYPES_REQUEST,
        payload: {
            briefcaseUuid
        }
    };
}
exports.fetchActivityTypesRequest = fetchActivityTypesRequest;
function fetchActivityTypesSuccess(rows) {
    return {
        type: ActionTypes.FETCH_ACTIVITY_TYPES_SUCCESS,
        payload: {
            rows
        }
    };
}
exports.fetchActivityTypesSuccess = fetchActivityTypesSuccess;
function fetchActivityTypesFailure(e) {
    return {
        type: ActionTypes.FETCH_ACTIVITY_TYPES_FAILURE,
        payload: e
    };
}
exports.fetchActivityTypesFailure = fetchActivityTypesFailure;
function fetchActivitiesRequest(options) {
    return {
        type: ActionTypes.FETCH_ACTIVITIES_REQUEST,
        payload: { options }
    };
}
exports.fetchActivitiesRequest = fetchActivitiesRequest;
function fetchActivitiesSuccess(activities) {
    return {
        type: ActionTypes.FETCH_ACTIVITIES_SUCCESS,
        payload: {
            activities
        }
    };
}
exports.fetchActivitiesSuccess = fetchActivitiesSuccess;
function fetchActivitiesFailure(e) {
    return {
        type: ActionTypes.FETCH_ACTIVITIES_FAILURE,
        payload: e
    };
}
exports.fetchActivitiesFailure = fetchActivitiesFailure;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=list.js.map